import Immutable, { fromJS } from 'immutable';
import { SET_PLUGIN_MANIFEST } from './constants/actions';

const initialState = fromJS({});

const reducer = (state = initialState, action) => {
  if (action.type === SET_PLUGIN_MANIFEST) {
    return state.setIn(
      [action.pluginId, action.version],
      Immutable.Iterable.isIterable(action.manifest) ? action.manifest : fromJS(action.manifest),
    );
  }
  return state;
};

export default reducer;
